export default __webpack_public_path__ + "static/media/330_business01-nl-web.1a5b4e85.png";